// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gwp_","colMin":"styles_colMin__FhJFj"};